import React from 'react'
import { useTranslation } from 'translations'
import { Section } from '../components/section'
import { ActionButtonA } from 'uiComponents/buttons'
import { ActionButton } from 'uiComponents/buttons'
import { FormikProps } from 'formik'
import PressAndHoldButton from 'uiComponents/buttons/pressAndHoldButton'

interface ActionsSectionProps {
    formik: FormikProps<any>
    showDeleteButton: boolean
    disableSaveButton: boolean
    returnToUserList: () => void
    deleteUser: (email: string) => void
}

export const ActionsSection = ({
    formik,
    showDeleteButton,
    disableSaveButton,
    returnToUserList,
    deleteUser,
}: ActionsSectionProps) => {
    const { t } = useTranslation()

    return (
        <Section className="actions">
            <div className="row">
                {showDeleteButton && (
                    <PressAndHoldButton
                        text={t('common.delete')}
                        destructive
                        onComplete={() => deleteUser(formik.values.email)}
                    />
                )}
                <div>
                    <ActionButtonA secondary size="large" onClick={returnToUserList}>
                        {t('common.cancel')}
                    </ActionButtonA>
                    <ActionButton id="submit" size="large" type="submit" disabled={disableSaveButton}>
                        {t('common.save')}
                    </ActionButton>
                </div>
            </div>
        </Section>
    )
}
